export const SIGNIN_RETRIED = 'signInRetried'
